import { render } from "./UpdateProfileInformationForm.vue?vue&type=template&id=37cdb62a"
import script from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__